import { render, staticRenderFns } from "./OOCommunicationMessages.vue?vue&type=template&id=66fbb5c2&scoped=true&"
import script from "./OOCommunicationMessages.vue?vue&type=script&lang=ts&"
export * from "./OOCommunicationMessages.vue?vue&type=script&lang=ts&"
import style0 from "./OOCommunicationMessages.vue?vue&type=style&index=0&id=66fbb5c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fbb5c2",
  null
  
)

export default component.exports